import { attr, hasMany, belongsTo } from '@ember-data/model';
import ShModel from './sh-model';

/**
 * This represents a request to fetch the assignment dashboard.
 *
 * NOTE: This model is used just in the client and is not backed by a database model, so calls to save(), update()
 * and etc. will not work.
 */
const AssignmentDashboardList = ShModel.extend({
  closedCount: attr('number'),
  draftCount: attr('number'),
  inReviewCount: attr('number'),
  liveCount: attr('number'),
  closedIsRead: attr('boolean'),
  draftIsRead: attr('boolean'),
  inReviewIsRead: attr('boolean'),
  liveIsRead: attr('boolean'),

  //relationships
  assignmentSummaries: hasMany('assignmentSummary', { async: false }),
  pagination: belongsTo('pagination', { async: false }),
});

export default AssignmentDashboardList;
